/* eslint-disable camelcase */
import request from 'superagent'
import types from '../types'
import Provider from '../../types/Provider'
import User from '../../types/User'
import Organization from '../../types/Organization'
import config from '../../../package.json'
const { api_port } = config

const { protocol, hostname } = window.location

const auth_url = api_port === '' ? `${protocol}//${hostname}/auth` :`${protocol}//${hostname}:${api_port}/auth`
const api_url = api_port === '' ? `${protocol}//${hostname}/api` : `${protocol}//${hostname}:${api_port}/api`

const loginUserRequested = () => ({
  type: types.LOGIN_USER_REQUESTED,
  payload: null
})

const loginUserRejected = (error: any) => ({
  type: types.LOGIN_USER_REJECTED,
  payload: error
})

const loginUserFulfilled = (data: any) => ({
  type: types.LOGIN_USER_FULFILLED,
  payload: data
})

export const loginUser = (data: {email: string; password: string}) => {
  return (dispatch: any) => {
    dispatch(loginUserRequested())
    request
      .post(`${auth_url}/authentication`)
      .set('Accept', 'application/json')
	    .send(data)
      .then((response) => {
        dispatch(loginUserFulfilled(response.body))
        if(response.body!==null){
          localStorage.setItem('p_sid', JSON.stringify({eid: response.body.eid}))
          localStorage.setItem('token', JSON.stringify(response.body.token))
        }
      })
      .catch((error) => {
        dispatch(loginUserRejected(error))
      })
  }
}

export const authUser = (isAuth: boolean) => ({
  type: types.AUTH_USER,
  payload: isAuth
})

export const unauthUser = () =>{
  localStorage.removeItem('p_sid')
  localStorage.removeItem('token')
  return {
    type: types.UNAUTH_USER,
    payload: false
  }
}

const getUserByEmailRequested = () => ({
  type: types.GET_USER_BY_EMAIL_REQUESTED,
  payload: null
})

const getUserByEmailRejected = (error: any) => ({
  type: types.GET_USER_BY_EMAIL_REJECTED,
  payload: error
})

const getUserByEmailFulfilled = (data: {user: Array<User>; token: string}) => {
  if(data.token !== 'false')
    localStorage.setItem('token', JSON.stringify(data.token))
  return {
    type: types.GET_USER_BY_EMAIL_FULFILLED,
    payload: data.user
  }
}

export const getUserByEmail = (data: {email: string; generateToken: boolean}) => {
  return (dispatch: any) => {
    dispatch(getUserByEmailRequested())
    request
      .post(`${auth_url}/user/email`)
      .set('Accept', 'application/json')
      .send(data)
      .then((response) => {
        dispatch(getUserByEmailFulfilled(response.body))
      })
      .catch((error) => {
        dispatch(getUserByEmailRejected(error))
      })
  }
}

const resetPasswordRequested = () => ({
  type: types.RESET_PASSWORD_REQUESTED,
  payload: null
})

const resetPasswordRejected = (error: any) => ({
  type: types.RESET_PASSWORD_REJECTED,
  payload: error
})

const resetPasswordFulfilled = (data: any) => ({
  type: types.RESET_PASSWORD_FULFILLED,
  payload: data
})

export const resetPassword = (data: {email: string}) => {
  return (dispatch: any) => {
    dispatch(resetPasswordRequested())
    request
      .post(`${auth_url}/user/email/validation`)
      .set('Accept', 'application/json')
      .send(data)
      .then((response) => {
        dispatch(resetPasswordFulfilled(response.body))
      })
      .catch((error) => {
        dispatch(resetPasswordRejected(error))
      })
  }
}

const updateUserPasswordRequested = () => ({
  type: types.UPDATE_USER_PASSWORD_REQUESTED,
  payload: true
})

const updateUserPasswordRejected = (error: any) => ({
  type: types.UPDATE_USER_PASSWORD_REJECTED,
  payload: error
})

const updateUserPasswordFulfilled = (data: any) => ({
  type: types.UPDATE_USER_PASSWORD_FULFILLED,
  payload: data
})

export const updateUserPassword = (userId: number, data: {password: string; pageType: string}) => {
  return (dispatch: any) => {
    dispatch(updateUserPasswordRequested())
    request
      .put(`${auth_url}/user/password/${userId}`)
      .set('Accept', 'application/json')
      .send(data)
      .then((response) => {
        dispatch(updateUserPasswordFulfilled(response.body))
      })
      .catch((error) => {
        dispatch(updateUserPasswordRejected(error))
      })
  }
}

export const updateCurrentUser = (data: { first_name: string; last_name: string}) => ({
  type: types.UPDATE_USER,
  payload: data
})

const authMemberRequested = () => ({
  type: types.AUTH_MEMBER_REQUESTED,
  payload: true
})

const authMemberRejected = (error: any) => ({
  type: types.AUTH_MEMBER_REJECTED,
  payload: error
})

const authMemberFulfilled = (data: any) => ({
  type: types.AUTH_MEMBER_FULFILLED,
  payload: data
})

export const authMember = (data: { e: string; p: string; u: string }) => {
  return (dispatch: any) => {
    dispatch(authMemberRequested())
    request
      .post(`${auth_url}/member`)
      .set('Accept', 'application/json')
      .send(data)
      .then((response) => {
        if(response.body!==null)
          localStorage.setItem('token', JSON.stringify(response.body.token))
        dispatch(authMemberFulfilled(response.body.user))
      })
      .catch((error) => {
        dispatch(authMemberRejected(error))
      })
  }
}

export const setUser = (data: User) => ({
  type: types.SET_USER,
  payload: data
})

export const setSelectedProvider = (provider: Provider) =>({
  type: types.SET_SELECTED_PROVIDER,
  payload: provider
})

export const setOrganizationView = (organizationView: boolean) =>({
  type: types.SET_ORGANIZATION_VIEW,
  payload: organizationView
})

export const showOrganizationModal = (organizationModal: boolean) =>({
  type: types.SHOW_ORGANIZATION_MODAL,
  payload: organizationModal
})

export const setSelectedOrganization = (organization: Organization) =>({
  type: types.SET_SELECTED_ORGANIZATION,
  payload: organization
})

export const setProviderList = (providerList: Array<Provider>) =>({
  type: types.SET_PROVIDER_LIST,
  payload: providerList
})

const addUserActivityRequested = () => ({
  type: types.ADD_USER_ACTIVITY_REQUESTED,
  payload: null
})

const addUserActivityRejected = (error: any) => ({
  type: types.ADD_USER_ACTIVITY_REJECTED,
  payload: error
})

const addUserActivityFulfilled = (data: any) => ({
  type: types.ADD_USER_ACTIVITY_FULFILLED,
  payload: data
})

export const addUserActivity = (data: { eid: string; activity: string; memberId?: number; organizationId?: number; providerId?: number; locationApplication?: number }, token: string ) => {
  return (dispatch: any) => {
    dispatch(addUserActivityRequested())
    request
      .post(`${api_url}/userActivity`)
      .set('Accept', 'application/json')
      .set('access-token',token)
	    .send(data)
      .then((response) => {
        dispatch(addUserActivityFulfilled(response.body))
      })
      .catch((error) => {
        dispatch(addUserActivityRejected(error))
      })
  }
}